<template>
  <div id="VerifyList" v-loading="loading" class="">
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        width=""
        prop="id"
        label="id"
        v-if="false"
      ></el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="uname" label="创建人"></el-table-column>
      <el-table-column prop="title" label="名称"></el-table-column>
      <el-table-column prop="teacherName" label="讲师"></el-table-column>
      <el-table-column prop="typeName" label="类别"></el-table-column>
      <el-table-column prop="type" label="类型">
        <template #default="scope">
          <span v-if="scope.row.type == '1'">视频</span>
          <span v-if="scope.row.type == '2'">音频</span>
          <span v-if="scope.row.type == '3'">文本</span>
          <span v-if="scope.row.type == '4'">文档</span>
          <span v-if="scope.row.type == '5'">音视频链接</span>
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间" :formatter="formatDate2">
        <!--          <template slot-scope="scope">-->
        <!--            <div>{{scope.row.ctime | formatDate}}</div>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :formatter="renderTime"
      >
        <!--          <template slot-scope="scope">-->
        <!--            <div>{{scope.row.updateTime | getTime }}</div>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="wareStatus" label="状态">
        <template #default="scope">
          <span v-if="scope.row.wareStatus == '0'">审核中</span>
          <span v-if="scope.row.wareStatus == '1'" style="color: green"
            >审核通过</span
          >
          <span v-if="scope.row.wareStatus == '2'" style="color: red"
            >退回</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <span class="operation" @click="preview(1, scope.row.id)">预览</span>
          <span class="operation" @click="preview(2, scope.row.id)">审核</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <Verify-edit
      v-if="previewDialog"
      :courseWareId="courseWareId"
      @closeVerifyEdit="closeVerifyEdit"
      ref="VerifyEdit"
    ></Verify-edit>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
import VerifyEdit from './Verify-edit'
export default {
  name: 'VerifyList',
  components: {
    VerifyEdit,
  },
  props: ['courseWareId'],
  data() {
    return {
      institutionId: '',
      previewDialog: false,
      loading: false,
      reviewStatus: '2',
      reviewStatusList: [
        { value: '2', label: '待审核' },
        { value: '1', label: '审核通过' },
        { value: '0', label: '审核未通过' },
      ],
      isShowQuery: false,
      // 专业列表
      categoryList: [],
      query: {
        professionId: '',
        uName: '',
      },
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowDialogNotPass: false,
      dialogArr: [],
    }
  },
  methods: {
    preview(type, id) {
      this.previewDialog = true
      this.$nextTick(() => {
        this.$refs.VerifyEdit.init(type, id)
      })
    },
    closeVerifyEdit() {
      this.getList()
      this.$emit('updateCoursewareManager')
      this.previewDialog = false
    },
    // 获取数据
    getList() {
      // this.loading = true
      const { page, pageSize } = this.pageObj
      const verifyStatus = this.reviewStatus
      const { professionId, courseName, admissionCard, uName, datetime } =
        this.query
      const [startTime, endTime] = datetime || ['', '']
      const courseWareId = this.courseWareId || this.$route.query.id
      api
        .checkVerify({
          page,
          pageSize,
          wareStatus: 0,
          courseWareId,
          institutionId: this.institutionId,
          uid: this.getUId,
        })
        .then(({ data }) => {
          data = data.data
          this.tableData = data.list
          this.total = data.total
          this.loading = false
        })
    },
    //获取机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then((data) => {
        if (data.data.code === 100000) {
          this.institutionId = data.data.data === null ? '' : data.data.data.id
          this.getList()
        }
      })
    },

    // 时间戳转日期
    formatDate2(row, column, cellValue, index) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },

    // 标准时间转日期
    renderTime(date) {
      if (
        date.updateTime == null ||
        date.updateTime == undefined ||
        date.updateTime == ''
      ) {
        return
      } else {
        var dates = new Date(date.updateTime).toJSON()
        return new Date(+new Date(dates) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
      }
    },

    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      this.getList()
    },

    // 重置查询
    resetQuery(formName) {
      this.$refs[formName].resetFields()
      this.handleQuery()
    },
  },
  created() {
    this.getSchoolByUid()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    },
    getTime(time) {
      let date = new Date(time)
      let y = date.getFullYear()
      let m =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return y + '-' + m + '-' + d
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.el-notification__content {
  text-align: center;
}
</style>
